/**
 * Shared combination and view date helpers.
 */

import { parseDateString } from './apiAndDateHelpers';

export interface GetCombinationDataParams {
  combination: { conceptName: string; packSize: string };
  packSizeTabs: Array<{ index: number; packSize: string; conceptName: string }>;
  packSizeFormData: Record<number, any>;
  formData: any;
}

export const getCombinationData = (params: GetCombinationDataParams): any => {
  const { combination, packSizeTabs, packSizeFormData, formData } = params;
  const globalFields = ['contracts', 'contractsData', 'supplierName', 'analysisDate', 'targetLaunchDate', 'analysisType', 'productName', 'analystName'];

  for (let tabIndex = 0; tabIndex < packSizeTabs.length; tabIndex++) {
    const tab = packSizeTabs[tabIndex];
    if (tab.conceptName === combination.conceptName && tab.packSize === combination.packSize) {
      const tabData = packSizeFormData[tab.index] || {};
      const combinationData: any = {
        ...tabData,
        conceptName: combination.conceptName,
        packSize: combination.packSize,
      };
      globalFields.forEach(field => {
        if (formData[field] !== undefined) {
          combinationData[field] = formData[field];
        }
      });
      return combinationData;
    }
  }

  let found = false;
  let combinationData: any = {};
  Object.keys(packSizeFormData).forEach((key) => {
    const tabData = packSizeFormData[parseInt(key)];
    if (tabData && tabData.conceptName === combination.conceptName && tabData.packSize === combination.packSize) {
      combinationData = {
        ...tabData,
        conceptName: combination.conceptName,
        packSize: combination.packSize,
      };
      globalFields.forEach(field => {
        if (formData[field] !== undefined) {
          combinationData[field] = formData[field];
        }
      });
      found = true;
    }
  });

  if (!found) {
    combinationData = {
      conceptName: combination.conceptName,
      packSize: combination.packSize,
    };
    globalFields.forEach(field => {
      if (formData[field] !== undefined) {
        combinationData[field] = formData[field];
      }
    });
  }
  return combinationData;
};

export interface GetDefaultViewDateParams {
  isStart: boolean;
  currentData: any;
  bidDetails: any;
}

export const getDefaultViewDate = (params: GetDefaultViewDateParams): Date => {
  const { isStart, currentData, bidDetails } = params;
  let usageDate = isStart ? currentData.usagePeriodStartDate : currentData.usagePeriodEndDate;

  if (!usageDate && bidDetails?.form_details?.form_data) {
    for (const concept of bidDetails.form_details.form_data) {
      if (concept.pack_size) {
        for (const packSizeKey in concept.pack_size) {
          const packData = concept.pack_size[packSizeKey];
          if (isStart && packData.start_date) {
            usageDate = packData.start_date;
            break;
          } else if (!isStart && packData.end_date) {
            usageDate = packData.end_date;
            break;
          }
        }
        if (usageDate) break;
      }
    }
  }

  if (usageDate) {
    try {
      const parsed = parseDateString(usageDate);
      if (parsed && !isNaN(parsed.getTime())) {
        return new Date(parsed.getFullYear(), parsed.getMonth(), 1);
      }
    } catch {
      // fall through
    }
  }

  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
};
